<span [class]="statusClass">
  <wm-common-text [data]="{ text: row?.status }"></wm-common-text>
</span>
